import { OrderStatus } from '@dss-libs/shared/type/common-types';

export const OrderStatusTranslationMapper = new Map([
  [OrderStatus.InProgress, 'IN_PROGRESS'],
  [OrderStatus.Cancelled, 'CANCELLED'],
  [OrderStatus.Completed, 'COMPLETED'],
  [OrderStatus.Declined, 'DECLINED'],
  [OrderStatus.Expired, 'EXPIRED'],
  [OrderStatus.Pending, 'PENDING'],
]);
